<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box configuracion">
  <h3>{{ title }}</h3>
  <hr />

  <div class="row mt-4 pasos">
    <div class="col-12 d-flex justify-content-sm-center">
      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>1</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Nombre y ponderación
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--active d-flex justify-content-sm-center align-items-center"
        >
          <span>2</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--active text-center mt-2">Bloques y rubros</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>3</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">preguntas</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>4</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Tipo de respuesta
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>5</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Configuración de respuestas
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>6</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Reglas de negocio
          </p>
        </div>
      </div>
    </div>
  </div>

  <form
    id="formNewBloque"
    (submit)="formNewBloque($event)"
    class="mt-5 mb-3"
    ngNativeValidate
  >
    <div class="row">
      <p>Límite de la ponderación: {{ ponderacionCheck }}</p>
    </div>
    <div class="row">
      <div class="col col-md-6">
        <div class="form-group">
          <label>Nombre del bloque:</label>
          <input type="text" class="form-control" id="Nombre" maxlength="128" />
        </div>
      </div>
      <div class="col col-md-6">
        <div class="form-group">
          <label>Ponderación:</label>
          <input
            type="number"
            class="form-control"
            id="Ponderacion"
            min="1"
            max="100"
            maxlength="3"
            (keypress)="ValidaPonderacion($event)"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button type="submit" class="btn btn-sm btn-primary">
          <i class="fa fa-save"></i> Guardar bloque
        </button>
      </div>
      <div class="col text-right">
        <button
          [disabled]="validBtnContinue"
          class="btn btn-sm btn-primary"
          (click)="redirectPaso3()"
        >
          <i class="fa fa-arrow-right"></i> Continuar
        </button>
      </div>
    </div>

    <div class="row" *ngIf="validBtnContinue">
      <div class="col text-right">
        <div class="text-danger">
          Agrega por lo menos un rubro en cada bloque y su ponderación.
        </div>
      </div>
    </div>
  </form>

  <div id="accordion">
    <div class="card mb-1" *ngFor="let bloque of bloques">
      <div
        class="card-header"
        id="heading{{ bloque.IdBloque }}"
        aria-expanded="true"
      >
        <div class="row">
          <div
            class="col-md-10"
            style="cursor: pointer"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + bloque.IdBloque"
            [attr.aria-controls]="'collapse' + bloque.IdBloque"
          >
            <h3>{{ bloque.Nombre }}</h3>
            <h6>
              Ponderacion: <span>{{ bloque.Ponderacion }}</span>
            </h6>
            <p>
              Orden: <span>{{ bloque.Orden }}</span>
            </p>
          </div>
          <div class="col-md-2 text-right">
            <button
              type="button"
              class="btn btn-primary btn-sm rounded-circle"
              (click)="editBloqueClick(bloque)"
            >
              <i class="fa fa-pencil"></i></button
            >&nbsp;
            <button
              type="button"
              class="btn btn-danger btn-sm rounded-circle"
              (click)="deleteBloqueClick(bloque.IdBloque)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        id="collapse{{ bloque.IdBloque }}"
        class="collapse"
        [attr.aria-labelledby]="'heading' + bloque.IdBloque"
        data-parent="#accordion"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <h6>Rubros</h6>
            </div>
            <div class="col text-right">
              <button
                class="btn btn-sm btn-primary rounded-circle"
                (click)="newRubroClick(bloque.IdBloque)"
              >
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Orden</th>
                      <th scope="col">Nombre</th>
                      <th scope="col">Descripción</th>
                      <th scope="col">Ponderación</th>
                      <th scope="col">Editar</th>
                      <th scope="col">Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let rubro of bloque.Rubros">
                      <td>{{ rubro.Orden }}</td>
                      <td>{{ rubro.Nombre }}</td>
                      <td>{{ rubro.Descripcion }}</td>
                      <td>{{ rubro.Ponderacion }}</td>
                      <td style="text-align: center">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm rounded-circle"
                          (click)="editRubroClick(rubro)"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                      </td>
                      <td style="text-align: center">
                        <button
                          type="button"
                          class="btn btn-danger btn-sm rounded-circle"
                          (click)="
                            deleteRubroClick(rubro.IdBloque, rubro.IdRubro)
                          "
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col text-right">
      <button
        id="btnOrdenamiento"
        class="btn btn-sm btn-primary"
        (click)="shoModalOrden()"
      >
        <i class="fa fa-first-order" aria-hidden="true"></i> Orden
      </button>
    </div>
  </div>
</div>

<!--Modal editar bloque-->
<div
  class="modal fade"
  id="modalEdit"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalEditLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="modalEditLabel">Editar bloque</h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        id="formEditBloque"
        (submit)="formEditBloque($event)"
        class="mt-5 mb-3"
        ngNativeValidate
      >
        <div class="modal-body">
          <div class="row">
            <div class="col col-md-6">
              <div class="form-group">
                <label>Nombre del bloque:</label>
                <input
                  required
                  type="text"
                  class="form-control"
                  id="NombreEdit"
                  maxlength="128"
                  value="{{ bloqueEdit.Nombre }}"
                />
              </div>
            </div>
            <div class="col col-md-3">
              <div class="form-group">
                <label>Ponderación:</label>
                <input
                  required
                  type="number"
                  class="form-control"
                  id="PonderacionEdit"
                  min="1"
                  max="100"
                  maxlength="3"
                  (keypress)="ValidaPonderacion($event)"
                  value="{{ bloqueEdit.Ponderacion }}"
                />
              </div>
            </div>
            <div class="col col-md-3">
              <div class="form-group">
                <label>Orden:</label>
                <input
                  required
                  type="number"
                  class="form-control"
                  id="OrdenEdit"
                  value="{{ bloqueEdit.Orden }}"
                  min="1"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-sm btn-primary">guardar</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!--Modal de los rubros-->
<div
  class="modal fade"
  id="modalNewRubro"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalEditLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="modalEditLabel">Nuevo rubro</h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        id="formNewRubro"
        (submit)="formNewRubro($event)"
        class="mt-5 mb-3"
        ngNativeValidate
      >
        <div class="modal-body">
          <div class="row">
            <p>
              <button
                class="btn btn-sm btn-primary rounded-circle"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </button>
            </p>
            <div class="collapse" id="collapseExample">
              <div class="card card-body">
                La ponderación de los rubros debe de sumar 100
              </div>
            </div>
          </div>
          <div class="row">
            <label>La Ponderación disponible es: {{ ponderacionRubro }} </label>
          </div>
          <div class="row">
            <div class="col col-md-6">
              <div class="form-group">
                <label>Nombre:</label>
                <input
                  required
                  type="text"
                  class="form-control"
                  id="NombreNewRubro"
                  maxlength="128"
                  value=""
                />
              </div>
            </div>
            <div class="col col-md-6">
              <div class="form-group">
                <label>Ponderación:</label>
                <input
                  required
                  type="number"
                  class="form-control"
                  id="PonderacionNewRubro"
                  min="1"
                  max="100"
                  (keypress)="ValidaPonderacion($event)"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col col-md-6">
              <div class="form-group">
                <label>Descripción:</label>
                <textarea
                  required
                  id="DescripcionNewRubro"
                  class="form-control"
                  rows="5"
                  maxlength="500"
                  placeholder="Descripcion aquí..."
                ></textarea>                
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-sm btn-primary">
            <i class="fa fa-save"></i> Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!--Modal de los Edit rubros-->
<div
  class="modal fade"
  id="modalEditRubro"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalEditLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="modalEditLabel">Nuevo rubro</h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        id="formEditRubro"
        (submit)="formEditRubro($event)"
        class="mt-5 mb-3"
        ngNativeValidate
      >
        <div class="modal-body">
          <div class="row">
            <div class="col col-md-6">
              <div class="form-group">
                <label>Nombre:</label>
                <input
                  required
                  type="text"
                  class="form-control"
                  id="NombreEditRubro"
                  maxlength="128"
                  value="{{ rubroEdit.Nombre }}"
                />
              </div>
            </div>
            <div class="col col-md-3">
              <div class="form-group">
                <label>Ponderación:</label>
                <input
                  required
                  type="number"
                  class="form-control"
                  id="PonderacionEditRubro"
                  min="1"
                  max="100"
                  value="{{ rubroEdit.Ponderacion }}"
                />
              </div>
            </div>
            <div class="col col-md-3">
              <div class="form-group">
                <label>Orden:</label>
                <input
                  required
                  type="number"
                  class="form-control"
                  id="OrdenEditRubro"
                  value="{{ rubroEdit.Orden }}"
                  min="1"
                  readonly
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col col-md-6">
              <div class="form-group">
                <label>Descripción:</label>
                <textarea
                  required
                  id="DescripcionEditRubro"
                  class="form-control"
                  rows="5"
                  maxlength="500"
                  placeholder="Descripcion aquí..."
                >{{ rubroEdit?.Descripcion?.trim() }}</textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-sm btn-primary">
            <i class="fa fa-save"></i> Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!--Modal de los Orden-->
<div
  class="modal fade"
  id="modalEditOrdenBloque"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalEditLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="modalEditLabel">Agregar Orden</h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        id="formEditRubro"
        (submit)="saveOrdenBloque()"
        class="mt-5 mb-3"
        ngNativeValidate
      >
        <div class="modal-body">
          <div class="row">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Bloque</th>
                    <th>Orden</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let bloque of bloques">
                    <td>{{ bloque.IdBloque }}</td>
                    <td>{{ bloque.Nombre }}</td>
                    <td>
                      <input
                        type="number"
                        id="txtOrden_{{ bloque.IdBloque }}"
                        class="form-control clsOrden"
                        value="{{ bloque.Nombre }}"
                      />
                    </td>
                    <td>
                      <button
                        type="button"
                        id="btnSaveOrden"
                        class="btn btn-primary"
                        (click)="
                          agregandoOrden(
                            bloque.idChecklist,
                            bloque.IdBloque,
                            'txtOrden_'
                          )
                        "
                        title="Asignar orden"
                      >
                        <i class="fa fa-save" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-sm btn-primary">
            <i class="fa fa-save"></i> Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
